import React from 'react';
import { Typography, Grid, Paper, Box, Button } from '@mui/material';

const Trading: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Trading Dashboard
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 3, height: '400px' }}>
            <Typography variant="h6" gutterBottom>
              Market Chart
            </Typography>
            {/* Add chart component here */}
            <Box sx={{ height: '300px', bgcolor: 'grey.100', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Typography>Chart Placeholder</Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Trading Controls
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Button variant="contained" color="primary" fullWidth>
                  Buy
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button variant="contained" color="secondary" fullWidth>
                  Sell
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Trading; 